import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'Id', // Column ID
                                    header: _('ID'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Nombre Usuario'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction(
                                        // Conditional visibility based on permissions
                                        'sensitiveInformationNames',
                                        'Add',
                                    ),
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de Creación'), // Column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Monto'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        // Number formatting
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo de ajuste'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description', // Column ID
                                    header: _('Descripción'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeBalance', // Column ID
                                    header: _('Tipo saldo'), // Column header
                                    options: [
                                        // Options for the dropdown
                                        { id: '0', value: _('Saldo recargas') },
                                        { id: '1', value: _('Saldo retiros') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserCreated', // Column ID
                                    header: _('Usuario Creo'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction(
                                        // Conditional visibility based on permissions
                                        'sensitiveInformationNames',
                                        'Add',
                                    ),
                                },
                                {
                                    id: 'BeforeAdjust', // Column ID
                                    header: _('Saldo Antes de Ajuste'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AfterAdjust', // Column ID
                                    header: _('Saldo Despues de Ajuste'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // ID for the pager
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url =
            devConfig.geturlApi() + // API base URL
            'es/BalanceAdjustments/GetBalanceAdjustments'; // API endpoint for balance adjustments
        var filter = ''; // Filter string for API requests
        var optionsTypes = []; // Array to hold adjustment types
        var popupAdd; // Variable for the add adjustment popup
        var popupSub; // Variable for the subtract adjustment popup

        // Event listener for filtering balance adjustments
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting the datatable
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click in the datatable
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for selecting a player
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        // Event listener for adding an adjustment
        this.on(this.app, 'addAdjustment:button', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'Select/GetTypesAdjustments', // API endpoint for adjustment types
                    '',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response
                            optionsTypes = resp.Data; // Store adjustment types
                            popupAdd = webix.ui({
                                // Create add adjustment popup
                                view: 'window',
                                id: 'AddAdjustments',
                                height: 550, // Popup height
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Ajustar Saldo'), // Popup title
                                            align: 'center',
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close', // Close icon
                                            click: function () {
                                                this.getTopParentView().hide(); // Hide popup on close
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center the popup
                                modal: true, // Make popup modal
                                body: {
                                    view: 'form', // Form inside the popup
                                    id: 'addform', // Form ID
                                    elements: [
                                        {
                                            view: 'text',
                                            label: _('Usuario Id:'), // User ID label
                                            name: 'UserId', // Input name
                                            labelWidth: 150, // Label width
                                            labelPosition: 'top', // Label position
                                            type: 'number', // Input type
                                            required: true, // Required field
                                        },
                                        {
                                            view: 'combo', // Dropdown for balance type
                                            label: _('Tipo Saldo:'),
                                            name: 'TypeBalance',
                                            required: true,
                                            labelPosition: 'top',
                                            options: [
                                                {
                                                    id: '0',
                                                    value: _('Saldo recargas'), // Option for recharge balance
                                                },
                                                {
                                                    id: '1',
                                                    value: _('Saldo retiros'), // Option for withdrawal balance
                                                },
                                            ],
                                            labelWidth: 150,
                                        },
                                        {
                                            view: 'combo', // Dropdown for adjustment type
                                            label: _('Tipo de ajuste') + ':',
                                            name: 'Type',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                            options: optionsTypes, // Options from the API
                                        },
                                        {
                                            view: 'textarea', // Textarea for description
                                            label: _('Descripción:'),
                                            name: 'Description',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                        },
                                        {
                                            view: 'text', // Input for amount
                                            label: _('Monto:'),
                                            name: 'Amount',
                                            type: 'number',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                        },
                                        {
                                            view: 'text', // Input for confirming amount
                                            label: _('Confirmar Monto:'),
                                            name: 'ConfirmAmount',
                                            type: 'number',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                        },
                                        {
                                            cols: [
                                                // Button layout
                                                {
                                                    view: 'button',
                                                    value: _('Cancelar'), // Cancel button
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide popup on cancel
                                                        $$('addform').setValues(
                                                            $$('addform').getCleanValues(), // Clear form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button',
                                                    type: 'form',
                                                    value: _('Guardar'), // Save button
                                                    click: function ($e) {
                                                        var values = $$('addform').getValues(); // Get form values
                                                        if (
                                                            $$('addform').validate() // Validate form
                                                        ) {
                                                            if (
                                                                values.Amount == values.ConfirmAmount // Check if amounts match
                                                            ) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for the request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'BalanceAdjustments/Adjustment', // API endpoint for adjustments
                                                                        '{"UserId":"' +
                                                                            values.UserId +
                                                                            '", "TypeBalance":"' +
                                                                            values.TypeBalance +
                                                                            '", "Amount":"' +
                                                                            values.Amount +
                                                                            '", "Description":"' +
                                                                            values.Description +
                                                                            '", "Type":"' +
                                                                            values.Type +
                                                                            '"}', // JSON payload
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Error message on failure
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                var json = JSON.parse(
                                                                                    text, // Parse response
                                                                                );
                                                                                if (
                                                                                    json.HasError // Check for errors in response
                                                                                ) {
                                                                                    if (json.CodeError != 110012) {
                                                                                        webix.message({
                                                                                            title: _('¡Error!'),
                                                                                            type: 'alert-error',
                                                                                            text: json.AlertMessage, // Show error message
                                                                                        });
                                                                                    }
                                                                                } else {
                                                                                    webix.message(
                                                                                        'Saldo Ajustado', // Success message
                                                                                    );
                                                                                    grid.clearAll(); // Clear grid data
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addform').setValues(
                                                                    $$('addform').getCleanValues(), // Clear form values
                                                                );
                                                                this.getTopParentView().hide(); // Hide popup
                                                            } else {
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Monto y confirmar monto no coinciden', // Error message for amount mismatch
                                                                    ),
                                                                });
                                                            }
                                                        } else {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Completa los campos...', // Error message for incomplete fields
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate form on change
                                            },
                                        },
                                    },
                                    rules: {
                                        Amount: function (value) {
                                            return value > 0; // Validation rule for amount
                                        },
                                    },
                                },
                            });
                            popupAdd.show(); // Show the add adjustment popup
                            $$('addform').clearValidation(); // Clear validation messages
                        },
                    },
                );
        });

        // Event listener for subtracting an adjustment
        this.on(this.app, 'subAdjustment:button', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'Select/GetTypesAdjustments', // API endpoint for adjustment types
                    '',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response
                            optionsTypes = resp.Data; // Store adjustment types
                            popupSub = webix.ui({
                                // Create subtract adjustment popup
                                view: 'window',
                                id: 'SubAdjustments',
                                height: 550, // Popup height
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Ajustar Saldo'), // Popup title
                                            align: 'center',
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close', // Close icon
                                            click: function () {
                                                this.getTopParentView().hide(); // Hide popup on close
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center the popup
                                modal: true, // Make popup modal
                                body: {
                                    view: 'form', // Form inside the popup
                                    id: 'subform', // Form ID
                                    elements: [
                                        {
                                            view: 'text',
                                            label: _('Usuario Id:'), // User ID label
                                            name: 'UserId', // Input name
                                            labelWidth: 150, // Label width
                                            labelPosition: 'top', // Label position
                                            type: 'number', // Input type
                                            required: true, // Required field
                                        },
                                        {
                                            view: 'combo', // Dropdown for balance type
                                            label: _('Tipo Saldo:'),
                                            name: 'TypeBalance',
                                            required: true,
                                            labelPosition: 'top',
                                            options: [
                                                {
                                                    id: '0',
                                                    value: _('Saldo recargas'), // Option for recharge balance
                                                },
                                                {
                                                    id: '1',
                                                    value: _('Saldo retiros'), // Option for withdrawal balance
                                                },
                                            ],
                                            labelWidth: 150,
                                        },
                                        {
                                            view: 'combo', // Dropdown for adjustment type
                                            label: _('Tipo de ajuste') + ':',
                                            name: 'Type',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                            options: optionsTypes, // Options from the API
                                        },
                                        {
                                            view: 'textarea', // Textarea for description
                                            label: _('Descripción:'),
                                            name: 'Description',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                        },
                                        {
                                            view: 'text', // Input for amount
                                            label: _('Monto:'),
                                            name: 'Amount',
                                            type: 'number',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                        },
                                        {
                                            view: 'text', // Input for confirming amount
                                            label: _('Confirmar Monto:'),
                                            name: 'ConfirmAmount',
                                            type: 'number',
                                            labelWidth: 150,
                                            labelPosition: 'top',
                                            required: true,
                                        },
                                        {
                                            cols: [
                                                // Button layout
                                                {
                                                    view: 'button',
                                                    value: _('Cancelar'), // Cancel button
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide popup on cancel
                                                        $$('subform').setValues(
                                                            $$('subform').getCleanValues(), // Clear form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button',
                                                    type: 'form',
                                                    value: _('Guardar'), // Save button
                                                    click: function ($e) {
                                                        var values = $$('subform').getValues(); // Get form values
                                                        if (
                                                            $$('subform').validate() // Validate form
                                                        ) {
                                                            if (
                                                                values.Amount == values.ConfirmAmount // Check if amounts match
                                                            ) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for the request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'BalanceAdjustments/Adjustment', // API endpoint for adjustments
                                                                        '{"UserId":"' +
                                                                            values.UserId +
                                                                            '", "TypeBalance":"' +
                                                                            values.TypeBalance +
                                                                            '", "Amount":"' +
                                                                            values.Amount * -1 +
                                                                            '", "Description":"' +
                                                                            values.Description +
                                                                            '", "Type":"' +
                                                                            values.Type +
                                                                            '"}', // JSON payload
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Error message on failure
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                var json = JSON.parse(
                                                                                    text, // Parse response
                                                                                );
                                                                                if (
                                                                                    json.HasError // Check for errors in response
                                                                                ) {
                                                                                    webix.message({
                                                                                        title: _('¡Error!'),
                                                                                        type: 'alert-error',
                                                                                        text: json.AlertMessage, // Show error message
                                                                                    });
                                                                                } else {
                                                                                    webix.message(
                                                                                        'Saldo Ajustado', // Success message
                                                                                    );
                                                                                    grid.clearAll(); // Clear grid data
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                                $$('subform').setValues(
                                                                    $$('subform').getCleanValues(), // Clear form values
                                                                );
                                                                this.getTopParentView().hide(); // Hide popup
                                                            } else {
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Monto y confirmar monto no coinciden', // Error message for amount mismatch
                                                                    ),
                                                                });
                                                            }
                                                        } else {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Completa los campos...', // Error message for incomplete fields
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate form on change
                                            },
                                        },
                                    },
                                    rules: {
                                        Amount: function (value) {
                                            return value > 0; // Validation rule for amount
                                        },
                                    },
                                },
                            });
                            popupSub.show(); // Show the subtract adjustment popup
                            $$('subform').clearValidation(); // Clear validation messages
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
